import React from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import { useTranslate } from '@im/react-localization';

export default function CommentAdd(
  props: Readonly<{ handleComment: (e: any) => void }>
) {
  const translate = useTranslate();
  return (
    <>
      <Typography fontWeight={'bold'} mb={1} mt={3} variant="body2">
        {translate('Pricing.Details')}
      </Typography>
      <TextField
        multiline
        onChange={(e) => props.handleComment(e.target.value)}
        rows={3}
        sx={{ mb: 2, width: '300px' }}
        variant="outlined"
      ></TextField>
    </>
  );
}
